import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const customerServiceCustomersEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-customer-service-customers" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
